import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const isEvaluacionesModalDisplayedStateSlice = createSlice({
	name: 'isEvaluacionesModalDisplayedState',
	initialState,
	reducers: {
		setiisEvaluacionesModalDisplayedStateSlice: (state, action: PayloadAction<boolean>) => {
			return action.payload;
		},
		resetisEvaluacionesModalDisplayedStateSlice: () => {
			return initialState;
		}
	}
});

export const { setiisEvaluacionesModalDisplayedStateSlice, resetisEvaluacionesModalDisplayedStateSlice } =
	isEvaluacionesModalDisplayedStateSlice.actions;

export default isEvaluacionesModalDisplayedStateSlice.reducer;
